import React,{useState} from "react"
import { Link } from 'react-router-dom'

import bg from '../../assets/images/bg.jpg'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

import { portfolioImg, social } from '../../data/portfolio'

import {FiSearch} from '../../assets/icons/vander'

import Lightbox from 'react-18-image-lightbox';
import "react-18-image-lightbox/style.css"

export default function PortfolioDetailThree() {
  let [isOpen, setisOpen] = useState(false);
  let [currentImageIndex, setCurrentImageIndex] = useState(0);

  let handleMovePrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + portfolioImg.length - 1) % portfolioImg.length);
};

let handleMoveNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % portfolioImg.length);
};
let handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setisOpen(true);
};
let currentImage = portfolioImg[currentImageIndex-1];

  return (
    <>
     <Navbar/> 
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Portfolio</h4>
                          <p className="text-muted mb-0">All work and portfolio posts are here,</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Work</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Work</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>
    <section className="section">
      <div className="container">
          <div id="grid" className="row">
            {portfolioImg.slice(0,8).map((item,index)=>{
              return(
                  <div className="col-md-3 col-12 spacing picture-item" key={index}>
                      <div className="card shadow border-0 portfolio portfolio-classic portfolio-primary rounded overflow-hidden">
                          <div className="card-img position-relative">
                              <img src={item} className="img-fluid" alt=""/>
                              <div className="card-overlay"></div>

                              <div className="pop-icon">
                                  <Link to="#" onClick={()=>handleImageClick(index+1)} className="btn btn-pills btn-icon lightbox"><FiSearch className=""/></Link>
                              </div>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-5">
          <div className="row">
              <div className="col-lg-8 col-md-6">
                  <div className="section-title me-md-4">
                      <h4 className="title mb-4">Project Description</h4>

                      <p className="text-muted">The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin language which more or less corresponds to 'proper' Latin. It contains a series of real Latin words. This ancient dummy text is also incomprehensible, but it imitates the rhythm of most European languages in Latin script. The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.</p>
                      <p className="text-muted mb-0">Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. If the fill text is intended to illustrate the characteristics of different typefaces, it sometimes makes sense to select texts containing the various letters and symbols specific to the output language.</p>
                  </div>
              </div>

              <div className="col-lg-4 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Project Details</h4>
                  </div>

                  <dl className="row mb-0">
                      <dt className="col-md-4 fw-medium col-5">Client :</dt>
                      <dd className="col-md-8 col-7 text-muted">Calvin Carlo</dd>

                      <dt className="col-md-4 fw-medium col-5">Category :</dt>
                      <dd className="col-md-8 col-7 text-muted">Web Design</dd>

                      <dt className="col-md-4 fw-medium col-5">Date :</dt>
                      <dd className="col-md-8 col-7 text-muted">15th April 2021</dd>

                      <dt className="col-md-4 fw-medium col-5">Website :</dt>
                      <dd className="col-md-8 col-7 text-muted">www.yourdomain.com</dd>

                      <dt className="col-md-4 fw-medium col-5">Location :</dt>
                      <dd className="col-md-8 col-7 text-muted">3/2/64 Mongus Street, UK</dd>
                  </dl>
              </div>

              <div className="col-12">
                  <div className="mt-5 pt-5 border-top">
                      <ul className="list-unstyled align-items-center social-icon social mb-0">
                        <li className="list-inline-item me-3">Share :</li>
                        {social.map((item,index)=>{
                        let Icon = item
                        return(
                          <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded-pill"><Icon/></Link></li>
                        )
                      })}
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>

    {isOpen && (
      <Lightbox
          mainSrc={currentImage}
          prevSrc={portfolioImg[(currentImageIndex + portfolioImg.length - 1) % portfolioImg.length]}
          nextSrc={portfolioImg[(currentImageIndex + 1) % portfolioImg.length]}

          onCloseRequest={() => setisOpen(false)}
          onMovePrevRequest={handleMovePrev}
          onMoveNextRequest={handleMoveNext}
      />
  )}
    </>
  )
}
